import { CreateNewFolderError } from './types/CreateNewFolderError';

export const datapoints = {
    FPFolderSelectorOpened: {
        datapoint: {
            name: 'FPFolderSelectorOpened',
        },
    },
    FPFolderSelectorDismissed: {
        datapoint: {
            name: 'FPFolderSelectorDismissed',
        },
    },
    FPFolderSelectorUpload: {
        datapoint: {
            name: 'FPFolderSelectorUpload',
        },
    },
    FPFolderSelectorCreateNewFolder: {
        datapoint: {
            name: 'FPFolderSelectorCreateNewFolder',
            customData: (errorType: CreateNewFolderError) => ({ error: errorType.toString() }),
        },
    },
    FPFolderSelectorLoadFolderFailed: {
        datapoint: {
            name: 'FPFolderSelectorLoadFolderFailed',
        },
    },
};
